import { Currency } from 'ha/constants/Currencies';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from '../constants';
import { PayInMethodType, PaymentMethod, PaymentMethodDetail } from './types';

export type Payload = {
  methodType: PayInMethodType;
  methodDetail?: PaymentMethodDetail;
  currency: Currency;
  token1?: string;
};

export type Response = PaymentMethod;

export default (makeCall: MakeCall) => (data: Payload) =>
  makeCall<Response>('POST', `${APIV2_URL}/payment/method/pay-in`, { data });
